import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=c3d6891c&scoped=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=c3d6891c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d6891c"]])

export default __exports__